module.exports = __webpack_public_path__ + "static/tickster-home-40ee7ad1ddd2f2e6e290cd5db0739bf8.jpg";